﻿window.cBuilderEmailWidgetImage = function (option) {
    var Me = this

    this.mGetButton = function () {
        var $DivBt = $("<div class='widget state-hover' typewidget='dxwidgetimage'/>").css({
            "padding": "5px",
            "width": "80px",
            "height": "95px",
            "cursor": "move",
            "margin": "5px",
            border: "3px solid " + theme.backgroundColorTitle,
            "text-align": "center",
            "display": "inline-block"
        })
        var $I = $("<i class='" + Me.icone + " dx-theme-accent-as-text-color' style='font-size:260%;height:50px;'></i>").appendTo($DivBt)
        var $Div = $("<div style='font-family:barlow condensed;font-size:100%;height:calc(100% - 60px);display:flex;align-items:center;justify-content:center;line-height:1;'>Image</div>").appendTo($DivBt)
        $DivBt.attr("title", "Ajouter une image cliquable")
        return $DivBt
    }

    this.mCreateElement = function () {
        option.element = $("<tr class='widget dxwidgetimage'>")
        $("<!-- DEBUT IMAGE -->").appendTo(option.element)
        var $Td = $("<td style='width:100%;' width='100%' class='tdwidget bodywidget widgetheightauto' widthpercent='30'>").appendTo(option.element)
        var jsonDuplik = JSON.parse(JSON.stringify(option.dxBuilderEmailPage.mJsonCssGuideProperty("image")))
        for (var prop in jsonDuplik) jsonDuplik[prop] = ""
        $Td.attr("jsoncssdatawidget", JSON.stringify(jsonDuplik))

        var $TablePaddingBorder = $("<table  border='0' cellspacing='0' cellpadding='0' style='width:100%'/>").appendTo($Td)
        var $Tr = $("<tr/>").appendTo($TablePaddingBorder)
        var $Td = $("<td class='contenuwidget tdpaddingborderwidget'/>").appendTo($Tr)

        var $Table = $("<table border='0' cellspacing='0' cellpadding='0' style='width:100%' class='tablewidget'>").appendTo($Td)
        var $TrTableBt = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:35%' class='tdleft'></td>").appendTo($TrTableBt)
        var $Td = $("<td style='width:30%' class='tdcenter'></td>").appendTo($TrTableBt)
        var $A = $("<a href='' target='_blank' style='pointer-events:none;' />").appendTo($Td)
        var $Table = $("<table border='0' cellspacing='0' cellpadding='0' style='width:100%' class='tablebt'>").appendTo($A)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='word-break:break-word;width:100%;'></td>").appendTo($Tr)
        var $img = $("<img src='" + imgPictureDefault + "' alt='' style='width:100%;height:auto;opacity:0.2;' width='0' img_default='1'>").appendTo($Td)

        var $Td = $("<td style='width:35%' class='tdright'></td>").appendTo($TrTableBt)
        $("<!-- FIN IMAGE -->").appendTo(option.element)
    }

    function mGetLink() { return $(option.element.find("a")[0]) }
    function mGetTdLeft() { return $(option.element.find(".tdleft")[0]) }
    function mGetTdCenter() { return $(option.element.find(".tdcenter")[0]) }
    function mGetTdRight() { return $(option.element.find(".tdright")[0]) }
    function mGetImage() { return $(option.element.find("img")[0]) }

    this.nom = "Image"
    this.icone = "fas fa-image"

    this.mAddCtrlSaisie = function (contentElement) {
        contentElement.empty()
        $("<br/>").appendTo(contentElement)

        var $DivImage = $("<div style='padding:0 10px;text-align:center;'/>").appendTo(contentElement)
        var $Img = $("<img src='' style='width:100%;max-width:250px;display:inline-block;'/>").appendTo($DivImage)
        $Img.attr("src", mGetImage().attr("src"))
        $Img.on("click", function (e) { dxBt.performClick(); })
        if (typeof mGetImage().attr("img_default") != "undefined" && mGetImage().attr("img_default") != "0") $Img.css("opacity", "0.2")

        var $Div = $("<div style='text-align:center;'/>").appendTo(contentElement)
        var $Table = $("<table style='display:inline-block;'/>").appendTo($Div)
        var $Tr = $("<tr/>").appendTo($Table)

        var $Td = $("<td style='width:1px;'/>").appendTo($Tr)
        $("<div/>").appendTo($Td).dxCtrlButton({
            text: "Coller",
            focusStateEnabled: false,
            onClick: function (e) {
                if (!navigator.clipboard || !navigator.clipboard.read) {
                    mNotify("Permission refusée pour accéder au presse-papiers.", "error", 6000);
                    return;
                }
                // Lit le contenu du presse-papiers
                navigator.clipboard.read().then(function (clipboardItems) {
                    clipboardItems.forEach(function (item) {
                        // Vérifie si l'élément est une image
                        if (item.types.includes('image/png')) {
                            item.getType('image/png').then(function (blob) {
                                // Convertit le Blob en Base64
                                const reader = new FileReader();
                                reader.onloadend = function () {
                                    mGetImage().css("opacity", 1)
                                    $Img.css("opacity", "1")
                                    mGetImage().attr("img_default", "0")
                                    $Img.attr("src", reader.result)
                                    mGetImage().attr("src", reader.result)
                                    $TdModif.show()
                                    $TdDel.show()
                                    option.onValueChanged()
                                };
                                reader.readAsDataURL(blob);
                            }).catch(function (error) {
                                mNotify("Erreur lors de la récupération du type de l'élément :" + error, "error", 6000);
                            });
                        } else {
                            mNotify("Aucune image dans le presse-papier.", "warning", 6000);
                        }
                    });
                }).catch(function (error) {
                    mNotify("Erreur lors de la lecture du presse-papiers :" + error, "error", 6000);
                });
            }
        }).dxCtrlButton("instance");

        var $Td = $("<td style='width:1px;'/>").appendTo($Tr)
        var dxBt = $("<div style='display:inline-block;'/>").appendTo($Td).dxCtrlButton({
            text: "Choisir une image",
            onClick: function (e) {
                var pop = $("<div/>").appendTo($DivGeneral).dxCtrlFileUploaderPopup({
                    bddCtrl: option.bddCtrl,
                    icone: true,
                    imgInternet: false,
                    imgPexel: true,
                    docCpt: false,
                    courrier: false,
                    multiple: false,
                    accept: ".png,.jpg,.jpeg,.gif,.bmp",
                    onValide: function (lstUrlFile) {
                        if (lstUrlFile.length > 0) {
                            var url = lstUrlFile[0]
                            $("<div/>").appendTo("body").dxCtrlPopupResizeImage({
                                bddCtrl: option.bddCtrl,
                                value: url,
                                onValidation: function (url) {
                                    mGetImage().css("opacity", 1)
                                    $Img.css("opacity", "1")
                                    mGetImage().attr("img_default", "0")
                                    $Img.attr("src", url)
                                    mGetImage().attr("src", url)
                                    $TdModif.show()
                                    $TdDel.show()
                                    option.onValueChanged()
                                }
                            })
                            //option.bddCtrl.mAjaxCall({
                            //    command: "migrein72dpiforemail",
                            //    urlimage: lstUrlFile[0]
                            //}, function (data) {
                            //    mGetImage().css("opacity", 1)
                            //    $Img.css("opacity", "1")
                            //    mGetImage().attr("img_default", "0")
                            //    $Img.attr("src", lstUrlFile[0])
                            //    mGetImage().attr("src", lstUrlFile[0])
                            //    $TdModif.show()
                            //    $TdDel.show()
                            //    option.onValueChanged()
                            //})
                        }
                        pop.hide();
                    },
                    optionImgInternet: {
                        bddCtrl: option.bddCtrl
                    },
                    optionFileUploader: {
                        bddCtrl: option.bddCtrl
                    }
                }).dxCtrlFileUploaderPopup("instance")
            }
        }).dxCtrlButton("instance")
        //image saisie//on modifie
        $TdModif = $("<td style='width:0px;display:none;'/>").appendTo($Tr)
        $("<div/>").appendTo($TdModif).dxCtrlButton({
            icon: "fas fa-pen",
            hint: "Modifier l'image",
            onClick: function (e) {
                var url = mGetImage().attr("src")
                if (url.startsWith("~")) url = url.substring(1)
                $("<div style='height:100%;width:100%'/>").appendTo("body").dxCtrlPopupImgEdit({
                    bddCtrl: option.bddCtrl,
                    value: url + "?d=" + (new Date()).getTime(),
                    readonly: false,
                    onConfirmModif: false,
                    onClose: function (data) {
                        if (data.contains("?")) data = data.split("?")[0]
                        $Img.attr("src", data)
                        mGetImage().attr("src", data)
                        mGetImage().attr("img_default", "0")
                        $TdModif.show()
                        $TdDel.show()
                        option.onValueChanged()

                        //$Img.attr("src", data.split("?")[0] + "?d=" + (new Date()).getTime())
                        //mGetImage().attr("src", data.split("?")[0] + "?d=" + (new Date()).getTime())
                        //$TdModif.show()
                        //$TdDel.show()
                        //option.onValueChanged()
                    }
                });
            }
        })
        $TdDel = $("<td style='width:0px;display:none;'/>").appendTo($Tr)
        $("<div/>").appendTo($TdDel).dxCtrlButton({
            icon: "fas fa-trash",
            hint: "Supprimer l'image",
            onClick: function (e) {
                mGetImage().css("opacity", "0.2")
                $Img.css("opacity", "0.2")
                $Img.attr("src", imgPictureDefault)
                mGetImage().attr("src", imgPictureDefault)
                mGetImage().attr("img_default", "1")
                $TdModif.hide()
                $TdDel.hide()
                option.onValueChanged()
            }
        })
        if (mGetImage().attr("img_default") != "0") {
            $TdModif.hide()
            $TdDel.hide()
        } else {
            $TdModif.show()
            $TdDel.show()
        }


        //$("<br/>").appendTo(contentElement)
        //$("<br/>").appendTo(contentElement)
        //$("<div style='width:1px;white-space:nowrap;font-size:140%;font-weight:bold;' class=''>Taille image:</div>").appendTo(contentElement)
        //$("<div/>").appendTo(contentElement).dxCtrlWidgetLargeur({
        //    value: option.parent.mGetBodyWidget().attr("widthpercent"),
        //    onValueChanged: function (value) {
        //        option.parent.mGetBodyWidget().attr("widthpercent", value)
        //        option.onValueChanged()
        //    }
        //})

        $("<div style='width:1px;white-space:nowrap;font-size:120%;font-weight:bold;margin-top:10px;' class=''>Lien:</div>").appendTo(contentElement)
        var dxLink = $("<div/>").appendTo(contentElement).dxCtrlBuilderEmailSaisieLink({
            bddCtrl: option.bddCtrl,
            value: mGetLink().attr("href"),
            title: mGetLink().attr("title") || "",
            dxBuilderEmailPage: option.dxBuilderEmailPage,
            lstfileheberge: option.dxBuilderEmailPage.option("lstfileheberge"),
            onValueChanged: function (link) {
                mGetLink().attr("href", link.link)
                mGetLink().attr("title", (link.title ? link.title : ""))
                switch (link.typeLink) {
                    case "Aucun":
                        mGetLink().css("pointer-events", "none")
                        break;
                    default:
                        mGetLink().css("pointer-events", "")
                        if (link.link.length == 0) { mGetLink().css("pointer-events", "none") }
                        else {
                            window.testUrl(link.link, option.bddCtrl, function (ok) {
                                if (ok) { dxLink.$DivError.hide() }
                                else {
                                    dxLink.$DivError.text("Le lien que vous avez saisi ne semble pas valide ou actif.")
                                    dxLink.$DivError.show()
                                }
                            })
                        }
                        break;
                }
                option.onValueChanged()
            }
        }).dxCtrlBuilderEmailSaisieLink("instance")

        $("<div style='width:1px;white-space:nowrap;font-size:120%;font-weight:bold;margin-top:10px;' class=''>Texte de remplacement:</div>").appendTo(contentElement)
        $("<div/>").appendTo(contentElement).dxCtrlTextBox({
            labelMode: 'floating',
            label: "Décrivez ce que vous voyez dans l'image...",
            value: mGetImage().attr("alt"),
            onValueChanged: function (e) {
                mGetImage().attr("alt", ((e.value == null) ? "" : e.value))
                option.onValueChanged()
            }
        })
    }

    this.mAddCtrlStyle = function (contentElement) {
        contentElement.empty()

        var jsonCssDataOriginalValue = JSON.parse(option.parent.mGetBodyWidget().attr("jsoncssdatawidget"))
        var jsonCssData = {}
        for (var prop in option.dxBuilderEmailPage.mJsonCssGuideProperty("image")) {
            jsonCssData[prop] = ""
            if (typeof jsonCssDataOriginalValue[prop] != 'undefined') jsonCssData[prop] = jsonCssDataOriginalValue[prop]
        }

        //$("<br/>").appendTo(contentElement)
        $("<div style='width:1px;white-space:nowrap;font-size:120%;font-weight:bold;' class=''>Largeur de l'image:</div>").appendTo(contentElement)
        $("<div/>").appendTo(contentElement).dxCtrlBuilderEmailStyleLargeur({
            allowDefaut: true,
            value: jsonCssData.width.toString().replace("%", ""),
            onValueChanged: function (value) {
                jsonCssDataOriginalValue.width = value + ((value.length == 0) ? "" : "%")
                option.parent.mGetBodyWidget().attr("jsoncssdatawidget", JSON.stringify(jsonCssDataOriginalValue))
                option.onValueChanged()
            }
        })


        $("<div style='width:1px;white-space:nowrap;font-size:120%;font-weight:bold;margin-top:10px;' class=''>Coins arrondis de l'image:</div>").appendTo(contentElement)
        $("<div/>").appendTo(contentElement).dxCtrlBuilderEmailStyleRadius({
            allowDefaut: option.allowDefaut,
            radiusTopRight: jsonCssData["border-top-right-radius"],
            radiusTopLeft: jsonCssData["border-top-left-radius"],
            radiusBottomRight: jsonCssData["border-bottom-right-radius"],
            radiusBottomLeft: jsonCssData["border-bottom-left-radius"],
            onValueChanged: function (e) {
                e.values.forEach(function (value) {
                    jsonCssDataOriginalValue[value.prop] = value.value
                })
                option.parent.mGetBodyWidget().attr("jsoncssdatawidget", JSON.stringify(jsonCssDataOriginalValue))
                option.onValueChanged()
            }
        })
    }

    this.mRemoveStyle = function () {
        var jsonCssData = JSON.parse(option.parent.mGetBodyWidget().attr("jsoncssdatawidget"))
        for (var prop in option.dxBuilderEmailPage.mJsonCssGuideProperty("image")) {
            delete jsonCssData[prop]
        }
        option.parent.mGetBodyWidget().attr("jsoncssdatawidget", JSON.stringify(jsonCssData))
        option.onValueChanged()
    }

    this.mUpdateCss = function () {
        var jsonCssData = JSON.parse(option.parent.mGetBodyWidget().attr("jsoncssdatawidget"))
        for (var prop in option.dxBuilderEmailPage.mJsonCssGuideProperty("image")) {
            if (prop == "width") {
                var widthPercent = 0
                if (typeof jsonCssData[prop] != 'undefined' && jsonCssData[prop].length > 0) {
                    widthPercent = jsonCssData[prop].replace("%", "")
                } else {
                    widthPercent = option.dxBuilderEmailPage.mJsonCssGuideProperty("image", prop).replace("%", "")
                }
                var rest = 100 - widthPercent

                var restWidthPx = option.parent.mGetTotalWidthContainerWithoutPaddingBorder()
                var widthPx = Math.floor(restWidthPx * widthPercent / 100)
                mGetImage().attr("width", widthPx)

                mGetTdCenter().attr("width", widthPercent + "%")
                mGetTdCenter().css("width", widthPercent + "%")
                switch (option.parent.mGetTextAlignCss()) {
                    case "left":
                        mGetTdLeft().attr("width", "0")
                        mGetTdLeft().css("width", "0px")
                        mGetTdRight().attr("width", rest + "%")
                        mGetTdRight().css("width", rest + "%")
                        break;
                    case "center":
                        var restDiv2 = rest / 2
                        mGetTdLeft().attr("width", restDiv2 + "%")
                        mGetTdLeft().css("width", restDiv2 + "%")
                        mGetTdRight().attr("width", restDiv2 + "%")
                        mGetTdRight().css("width", restDiv2 + "%")
                        break;
                    case "right":
                        mGetTdLeft().attr("width", rest + "%")
                        mGetTdLeft().css("width", rest + "%")
                        mGetTdRight().attr("width", "0")
                        mGetTdRight().css("width", "0px")
                        break;
                }
            } else if (prop.startsWith("border-")) {
                if (typeof jsonCssData[prop] != 'undefined' && jsonCssData[prop].length > 0) {
                    mGetImage().css(prop, jsonCssData[prop])
                } else {
                    mGetImage().css(prop, option.dxBuilderEmailPage.mJsonCssGuideProperty("image", prop))
                }
            } else {
                if (typeof jsonCssData[prop] != 'undefined' && jsonCssData[prop].length > 0) {
                    mGetTdCenter().css(prop, jsonCssData[prop])
                } else {
                    mGetTdCenter().css(prop, option.dxBuilderEmailPage.mJsonCssGuideProperty("image", prop))
                }
            }
        }
    }

    var imgPictureDefault = "data:image/png;base64,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"

}